/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/create_landing_page_app" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdCreateLandingPageAppCacheKeys } from "./constants";
import type { PostEngagementLandingPagesAppGroupIdCreateLandingPageAppProps } from "./types";

export const postEngagementLandingPagesAppGroupIdCreateLandingPageApp = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdCreateLandingPageAppCacheKeys,
  (props: PostEngagementLandingPagesAppGroupIdCreateLandingPageAppProps): Promise<void> => {
    return fetch(`/engagement/landing_pages/${props.appGroupId}/create_landing_page_app`, "POST", props);
  }
);
